import * as Yup from "yup";

export const homePageValidations = Yup.object().shape({
  heading: Yup.string().required("heading is required."),
  content: Yup.string().required("content is required."),
  section: Yup.string().required("section is required."),
});

export const BannerValidations = Yup.object().shape({
  heading: Yup.string().required("Heading is required"),
  content: Yup.string().required("Content is required"),
  bread_crumbs: Yup.string().required("Breadcrumbs are required"),
});

export const customiseablePageValidation = Yup.object().shape({
  heading: Yup.string().required("heading is required."),
  content: Yup.string().required("content is required."),
  section: Yup.string().required("section is required."),
  start_date: Yup.date()
    .required("Start Date is required.")
    .typeError("Start Date must be a valid date"),
  end_date: Yup.date()
    .required("End Date is required.")
    .typeError("End Date must be a valid date")
    .min(Yup.ref("start_date"), "End Date cannot be before Start Date."),
});
